import kylogger from "@ky/sdk/dist/log/kylogger";
function install(Vue) {
  if (install.installed) {
    return;
  }
  install.installed = true;
  Vue.prototype.$log = kylogger;
  window.$log = kylogger;
}
kylogger.install = install;

kylogger.install = install;
export default kylogger;
